if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super()

      this.label = this.querySelector('.custom-select-label')
      this.svg = this.querySelector('.custom-select-label-and-svg svg')
      this.dropdown = this.querySelector('.custom-select-options')
      this.options = this.querySelectorAll('.custom-select-option')

      this.realSelect = this.querySelector('.ProductForm-quantity-select')
      this.realOptions = this.querySelectorAll(
        '.ProductForm-quantity-select-option'
      )

      this.toggleDropdown = this.toggleDropdown.bind(this)
      this.selectOption = this.selectOption.bind(this)
      this.handleOutsideClick = this.handleOutsideClick.bind(this)
      this.checkForVariantChange = this.checkForVariantChange.bind(this)

      this.currentVariantId = null

      this.closestPurchaseOptions = this.closest(
        'purchase-option.ProductForm-purchase-options'
      )
      this.checkBox = this.closestPurchaseOptions.querySelector(
        '.purchase-option-checkbox'
      )
      this.checkBoxElement = this.closestPurchaseOptions.querySelector(
        '.custom-purchase-option-checkbox'
      )
      this.checkBoxContainer = this.closestPurchaseOptions.querySelector(
        '.ProductForm-purchase-options-checkbox'
      )
    }

    connectedCallback() {
      this.label.addEventListener('click', this.toggleDropdown)
      this.svg.addEventListener('click', this.toggleDropdown)

      this.options.forEach((option) => {
        option.addEventListener('click', this.selectOption)
      })

      this.checkForVariantChange()

      window.addEventListener('popstate', this.checkForVariantChange)

      const originalPushState = history.pushState
      const originalReplaceState = history.replaceState

      history.pushState = (...args) => {
        originalPushState.apply(history, args)
        this.checkForVariantChange()
      }

      history.replaceState = (...args) => {
        originalReplaceState.apply(history, args)
        this.checkForVariantChange()
      }
    }

    disconnectedCallback() {
      this.label.removeEventListener('click', this.toggleDropdown)
      this.svg.removeEventListener('click', this.toggleDropdown)

      this.options.forEach((option) => {
        option.removeEventListener('click', this.selectOption)
      })
      window.removeEventListener('popstate', this.checkForVariantChange)
      document.removeEventListener('click', this.handleOutsideClick)
    }

    checkForVariantChange() {
      const url = new URL(window.location.href)

      const variantId = url.searchParams.get('variant')

      if (variantId && variantId !== this.currentVariantId) {
        this.currentVariantId = variantId

        const matchingVariant = window.productData.variants.find(
          (variant) => variant.id == variantId
        )

        if (matchingVariant) {
          const inventoryQuantity = matchingVariant.inventory_quantity

          const maxQuantity = Math.min(inventoryQuantity, 10)

          if (maxQuantity === 0) {
            this.label.classList.add('disabled')

            this.svg.classList.add('disabled')

            this.realSelect.disabled = true
          } else {
            this.label.classList.remove('disabled')

            this.svg.classList.remove('disabled')

            this.realSelect.disabled = false
          }

          this.options.forEach((option) => {
            option.classList.remove('selected')
          })

          const firstOption = this.options[0]

          const firstRealOption = this.realOptions[0]

          if (firstOption) {
            firstOption.classList.add('selected')

            this.label.innerText = firstOption.innerText.trim().split(' ')[0]
          }

          if (firstRealOption) {
            firstRealOption.selected = true

            this.realSelect.dispatchEvent(new Event('change'))
          }

          this.options.forEach((option, index) => {
            option.style.display = index < maxQuantity ? 'block' : 'none'
          })

          for (let i = 0; i < this.realOptions.length; i++) {
            this.realOptions[i].style.display =
              i < maxQuantity ? 'block' : 'none'
          }
          
          this.updateAddToCartPrice(1)
        } else {
          console.log('Variant not found')
        }
      }
    }

    toggleDropdown() {
      const isDropdownOpened = !this.dropdown.classList.contains('hidden')
      if (!isDropdownOpened) {
        document.addEventListener('click', this.handleOutsideClick)
      } else {
        document.removeEventListener('click', this.handleOutsideClick)
      }

      this.dropdown.classList.toggle('hidden')
      this.label.classList.toggle('dropdown-opened')
    }

    handleOutsideClick(event) {
      if (!this.contains(event.target)) {
        this.dropdown.classList.add('hidden')
        this.label.classList.remove('dropdown-opened')
        document.removeEventListener('click', this.handleOutsideClick)
      }
    }
    
    formatPrice(price) {
      return price % 1 === 0 ? price.toFixed(0) : price.toFixed(2)
    }

    updateAddToCartPrice(quantity) {
      const atcBtn = document.querySelector('.ProductPage #rsc-addtocart')
      if (Number.isNaN(quantity) || quantity < 1 || !atcBtn) return

      const priceEl = atcBtn.querySelector('.atc-btn-price-text')
      if (!priceEl) return

      const updatedPrice = quantity * (atcBtn.dataset.price / 100)

      if (!atcBtn.dataset.comparePrice) {
        priceEl.innerHTML = ` - $${this.formatPrice(updatedPrice)}`
      } else {
        const comparePrice = quantity * (atcBtn.dataset.comparePrice / 100)

        if (atcBtn.dataset.bulkUi === 'badge' && quantity >= 3) {
          priceEl.innerHTML = ` - $${this.formatPrice(updatedPrice * 0.75)} <s>$${this.formatPrice(updatedPrice)}</s>`
        } else {
          if (atcBtn.dataset.price != atcBtn.dataset.comparePrice) {
            priceEl.innerHTML = ` - $${this.formatPrice(
              updatedPrice
            )} <s>$${this.formatPrice(comparePrice)}</s>`
          } else {
            priceEl.innerHTML = ` - $${this.formatPrice(updatedPrice)}`
          }
        }
      }
    }

    selectOption(event) {
      const selectedOption = event.currentTarget

      const quantity = parseInt(selectedOption.innerText)

      this.updateAddToCartPrice(quantity)

      this.options.forEach((option) => {
        option.classList.remove('selected')
      })

      selectedOption.classList.add('selected')
      this.label.innerText = selectedOption.innerText.trim().split(' ')[0]
      this.dropdown.classList.add('hidden')
      this.label.classList.remove('dropdown-opened')

      document.removeEventListener('click', this.handleOutsideClick)

      if (this.classList.contains('A-B-test')) {
        const secondRealSelect = document.querySelector(
          '.control-group .ProductForm-quantity-select'
        )
        const secondSelectOption = Array.from(
          document.querySelectorAll(
            '.control-group .ProductForm-quantity-select-option'
          )
        ).find(
          (option) =>
            option.value === selectedOption.innerText.trim().split(' ')[0]
        )

        if (secondSelectOption) {
          secondSelectOption.selected = true
          secondRealSelect.dispatchEvent(new Event('change'))
        } else {
          console.log('No matching option found.')
        }
      }

      for (let i = 0; i < this.realOptions.length; i++) {
        let realOption = this.realOptions[i]

        if (
          realOption.value === selectedOption.innerText.trim().split(' ')[0]
        ) {
          realOption.selected = true
          this.realSelect.dispatchEvent(new Event('change'))
          break
        }
      }
    }
  }

  customElements.define('custom-select', CustomSelect)
}

if (!customElements.get('purchase-option')) {
  class PurchaseOption extends HTMLElement {
    constructor() {
      super()

      this.customCheckbox = this.querySelector(
        '.custom-purchase-option-checkbox'
      )
      this.checkbox = this.querySelector('.purchase-option-checkbox')
      this.options = this.querySelectorAll('.A-B-test .custom-select-option')
      this.lastOption = this.options[this.options.length - 1]
      this.firstOption = this.options[0]
      this.checkboxContainer = this.querySelector(
        '.ProductForm-purchase-options-checkbox'
      )

      this.onOptionClick = this.onOptionClick.bind(this)
    }

    onOptionClick(e) {
      if (e.target.innerText == this.lastOption.innerText) {
        this.customCheckbox.classList.add('custom-checkbox-check')
        this.checkboxContainer.classList.add('background')
        this.checkbox.checked = true
      } else {
        this.customCheckbox.classList.remove('custom-checkbox-check')
        this.checkboxContainer.classList.remove('background')
        this.checkbox.checked = false
      }
    }

    connectedCallback() {
      this.options.forEach((option) => {
        option.addEventListener('click', this.onOptionClick)
      })
    }

    disconnectedCallback() {
      this.options.forEach((option) => {
        option.removeEventListener('click', this.onOptionClick)
      })
    }
  }

  customElements.define('purchase-option', PurchaseOption)
}
